<template>
  <div>
    <h3>Connect Band</h3>
    <p>Connect to Band to post notifications to Band group.</p>
    <b-button variant="primary" @click="connectBand">
      <div class="d-flex align-items-center">
        <img
          src="https://ssl.pstatic.net/cmstatic/webclient/band-web/dres/20250820003248/images/spr_svg/new/ico-gnb-band-logo.svg"
          alt="Band Logo"
          class="mr-2"
          style="filter: invert(1);"
        />
        <span class="h5">Connect</span>
      </div>
    </b-button>
  </div>
</template>
<script>
export default {
  name: "ConnectBand",
  methods: {
    connectBand() {
      const client_id = "466085760";
      const child = window.open(
        `https://auth.band.us/oauth2/authorize?response_type=code&client_id=${client_id}&redirect_uri=https://admin.hisacademyoh.com/band/`,
        "_blank",
        "left=100,top=100,width=320,height=320"
      );
      console.log(child);
    },
  },
};
</script>
